// extracted by mini-css-extract-plugin
export default {"tooltip":"tR-z","arrow":"uR-z"};